<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>密保管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--&lt;!&ndash;搜索与添加区域&ndash;&gt;-->
                <!--<el-col :span="4">-->
                    <!--<el-input placeholder="请输入检测设备ID" v-model="queryInfo.equipmentId" clearable-->
                              <!--@clear="getFirmWareEditionList">-->
                    <!--</el-input>-->
                <!--</el-col>-->
                <!--&lt;!&ndash;搜索按钮&ndash;&gt;-->
                <!--<el-col :span="3">-->
                    <!--<el-button type="primary" icon="el-icon-search" @click="getFirmWareEditionList">{{$t('common.search')}}</el-button>-->
                <!--</el-col>-->

                <el-col :span="2" style="float: right">
                    <el-button type="primary" icon="el-icon-plus" @click="openAddFirmWareEdition">{{$t('common.add')}}</el-button>
                </el-col>
            </el-row>
            <!--记录区域-->
            <el-table :data="firmWareEditionList.records" border stripe style="width: 100%" v-loading="loading">
                <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                <el-table-column label="密保类型" prop="questionType" align="center"></el-table-column>
                <el-table-column label="密保问题" prop="question" align="center"></el-table-column>
                <el-table-column label="创建时间" sortable prop="creationTime" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <!--修改-->
                        <!--<el-tooltip effect="dark" content="修改" placement="top" :enterable="false">-->
                            <!--<el-button type="primary" icon="el-icon-edit" size="mini"-->
                                       <!--@click="showEditDialog(scope.row)"></el-button>-->
                        <!--</el-tooltip>-->
                        <!--删除-->
                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                       @click="removeFirmWareEditionById(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="firmWareEditionList.total">
            </el-pagination>
        </el-card>

        <!--        添加数据弹框-->
        <el-dialog
                title="添加密保问题"
                :visible.sync="addDialogVisible"
                width="700px">
            <el-form :model="addFirmWareEdition" label-width="100px" :inline="true">
                <!--<el-form-item label="检测设备ID" prop="versions">-->
                <!--<el-input v-model="addFirmWareEdition.equipmentId" style="width: 500px"-->
                <!--placeholder="检测设备ID"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="密保类型" prop="type">
                    <el-select  v-model="addFirmWareEdition.questionType" placeholder="请选择密保类型" style="width: 500px">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="密保问题" prop="versions">
                    <el-input type="textarea" v-model="addFirmWareEdition.question" style="width: 500px"
                              placeholder="请输入密保问题"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addFirmWareEditionInfo">确 定</el-button>
            </span>
        </el-dialog>
        <!--        修改数据弹框-->
        <el-dialog
                title="增加设备"
                :visible.sync="updateDialogVisible"
                width="700px">
            <el-form :model="addFirmWareEdition" label-width="100px" :inline="true">
                <el-form-item label="检测设备地址" prop="versions">
                    <el-input v-model="updateFirmWareEdition.equipmentMac" style="width: 500px"
                              placeholder="检测设备地址"></el-input>
                </el-form-item>
                <!--<el-form-item label="通知内容图片" style="height: 100px">-->
                <!--<el-upload-->
                <!--:action="baseUrl"-->
                <!--:limit="1"-->
                <!--list-type="picture"-->
                <!--:show-file-list="true"-->
                <!--:on-exceed="handleExceed"-->
                <!--:on-success="handleUploadSuccess"-->
                <!--:file-list="fileList2">-->
                <!--<el-button size="small" type="primary">点击上传</el-button>-->
                <!--</el-upload>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="创建时间" prop="creationTime">-->
                <!--<el-date-picker-->
                <!--v-model="addFirmWareEdition.creationTime"-->
                <!--type="datetime"-->
                <!--value-format="yyyy-MM-dd HH:mm:ss"-->
                <!--placeholder="选择日期时间" style="width: 500px">-->
                <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="语言版本" prop="type">
                    <el-select  v-model="updateFirmWareEdition.internationalVersion" placeholder="请选择语言版本" style="width: 500px">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="水果类型">
                    <!--<el-checkbox-group v-model="addFirmWareEdition.ids">-->
                    <!--<el-checkbox v-for="menu in menuList" :label="menu.id" :key="menu.id">{{menu.name}}</el-checkbox>-->
                    <!--</el-checkbox-group>-->
                    <el-select
                            v-model="updateFirmWareEdition.ids"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            placeholder="请选择水果">
                        <el-option
                                v-for="item in menuList"
                                :key="item.fruitId"
                                :label="item.name"
                                :value="item.fruitId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateFirmWareEditionInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "FirmWareEditionList",
        data() {
            return {
                menuList:[
                    {
                        fruitId:123,
                        name:456
                    },
                    {
                        fruitId:1234,
                        name:4565
                    }
                ],
                appType:'',
                options: [
                    {
                        value: '日期',
                        label: '日期'
                    }, {
                        value: '时间',
                        label: '时间'
                    }, {
                        value: '文本',
                        label: '文本'
                    }
                ],
                updateDialogVisible:false,
                addDialogVisible: false,
                baseUrl: "http://brix.zhengtusensor.com:8888/zhengtusensor/upload/FirmWareEdition",
                fileList: [],
                fileList1:[],
                fileList2:[],
                addFirmWareEdition: {

                },
                updateFirmWareEdition: {
                    isForce: 1
                },
                loading: false,
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10,
                },
                firmWareEditionList: {
                    records: [],
                    total: 0
                },
            }
        },
        created() {
            this.getFirmWareEditionList();
            this.getFruit();
        },
        methods: {

            async updateFirmWareEditionInfo() {
                let name=[]
                for(let i=0;i<this.updateFirmWareEdition.ids.length;i++){
                    for(let y=0;y<this.menuList.length;y++){
                        if(this.updateFirmWareEdition.ids[i]==this.menuList[y].fruitId){
                            name.push(this.menuList[y].name)
                        }

                    }

                }
                let params = {};
                console.log(this.fileList)
                this.updateFirmWareEdition.userName=window.sessionStorage.getItem("username")
                this.updateFirmWareEdition.userId=window.sessionStorage.getItem("userId")
                this.updateFirmWareEdition.ids=this.updateFirmWareEdition.ids.join()
                this.updateFirmWareEdition.idsName=name.join()
                params = this.updateFirmWareEdition;
                let {data: res} = await this.$http.post(`/appdevice/addAppDevice`, params);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.updateDialogVisible = false
                this.getFirmWareEditionList()

            },
            showEditDialog(row){
                this.updateDialogVisible=true
                this.updateFirmWareEdition=row
                this.updateFirmWareEdition.ids=this.updateFirmWareEdition.ids.split(",")
                let num=[]
                for(let i=0;i<this.updateFirmWareEdition.ids.length;i++){
                    num.push(Number(this.updateFirmWareEdition.ids[i]))
                }
                this.updateFirmWareEdition.ids=num
            },
            async getFruit(){
                let {data: res} = await this.$http.post(`/api/fruit/selectAll`);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.menuList = res.data;
                console.log(this.menuList)

            },
            handleUploadSuccess(response, file, fileList) {
                this.fileList = fileList
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            async addFirmWareEditionInfo() {

               let  params = this.addFirmWareEdition;
                let {data: res} = await this.$http.post(`/question/addQuestion`, params);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.addDialogVisible = false
                this.$message.success("添加成功");
                this.getFirmWareEditionList()

            },
            openAddFirmWareEdition() {
                this.addFirmWareEdition = { isForce: 1}
                this.addDialogVisible = true
            },
            // 获取记录列表
            async getFirmWareEditionList() {
                this.loading = true
                let {data: res} = await this.$http.post(`/question/selectPageQuestion`, this.queryInfo);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.firmWareEditionList.records = res.data.records;
                this.firmWareEditionList.total = res.data.total;
                this.loading = false
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getFirmWareEditionList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getFirmWareEditionList()
            },
            // 根据id删除记录信息
            async removeFirmWareEditionById(record) {
                // 弹框询问用户是否删除记录
                await this.$confirm('此操作将永久删除该密保问题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除记录
                    const {data: res} = await this.$http.post(`/question/deleQuestion`, record);
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取记录列表
                    this.getFirmWareEditionList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
